
import TheHeader from "../components/partials/Header/TheHeader.vue";

export default {
  name: "EmptyLayout",
  layout: "empty",
  components: { TheHeader },
  props: {
    error: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  methods: {},
  head() {
    return {
      title:
        this.error.statusCode === 404
          ? "آبالون | صفحه مورد نظر یافت نشد"
          : "آبالون | خطا در سرور",
    };
  },
};
